import animateScrollTo from "animated-scroll-to";
import { sections } from "../sections";
import { SectionHeader } from "./util";

export const Section = ({ name, description = undefined, children }) => {
  if (!sections[name]) {
    console.error("Missing section " + name, sections);
    return null;
  }
  const { Icon, title, options } = sections[name];
  const iconSize = options?.iconSize || 5;
  return (
    <section id={"section_" + name} className="space-y-3">
      <SectionHeader
        icon={<Icon className={`w-${iconSize} h-${iconSize} text-sidebar-menu-active`} />}
        title={title}
        description={description || "Hier moet nog een tekst komen over " + title}
      />
      {children}
    </section>
  );
};

export const scrollToSection = (section: string) => {
  if (!section) return;
  if (!section.startsWith("section_")) section = "section_" + section;
  const elem = document.getElementById(section);
  if (!elem) return console.warn("can not scroll to section", section);
  animateScrollTo(elem.offsetTop - (56 - 1), { maxDuration: 1000 });
};
export const onClickScrollToSection = (e) => scrollToSection(e.currentTarget?.dataset?.name);
